import { displayNetOdds } from '../../utils/casinoNetOdds';
import { formatBetNation, formatBetOdds } from '../../utils/casinoMyBets';

// Statement bet-result endpoint ka casino row → CasinoBetsAddon shape.
// Server already settled win (net P/L), side (BACK/LAY) aur deleted bhejta hai.
// (frontend CasinoResultModal.mapBet ka admin port)
const num = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
};

function pad(n) { return String(n).padStart(2, '0'); }
export function fmtDateTime(d) {
  if (!d) return '';
  const dt = new Date(d);
  if (isNaN(dt.getTime())) return '';
  return `${pad(dt.getDate())}/${pad(dt.getMonth() + 1)}/${dt.getFullYear()} ${pad(dt.getHours())}:${pad(dt.getMinutes())}:${pad(dt.getSeconds())}`;
}

// Server ka `win` trust karo; na ho to result_status se derive, pending/void = 0.
function betWin(b, lay) {
  if (b.win !== undefined && b.win !== null) return num(b.win);
  const stake = num(b.stake ?? b.amount);
  const odds = num(b.odds ?? b.rate);
  const status = String(b.result_status ?? '').toLowerCase();
  if (status === 'won') return lay ? stake : stake * (odds - 1);
  if (status === 'lost') return lay ? -stake * (odds - 1) : -stake;
  return 0;
}

function betDeleted(b) {
  if (b.deleted !== undefined) return b.deleted === true;
  const s = `${b.status ?? ''} ${b.result_status ?? ''}`.toLowerCase();
  return s.includes('deleted') || s.includes('void');
}

// t1: the round's result — 1 Card Meter's Rate is read from it.
export function mapCasinoBet(b, gameName, t1) {
  const side = b.side
    ? String(b.side).toLowerCase()
    : String(b.type ?? b.bet_type ?? '').toLowerCase() === 'lay' ? 'lay' : 'back';
  const name = b.player_name ?? b.selection ?? b.nat ?? '';
  const nation = formatBetNation(gameName, name, b);
  const win = betWin(b, side === 'lay');
  return {
    id: b.id,
    username: b.user?.username ?? b.username ?? '',
    bhav: '-',
    // Unlimited Joker: formatBetNation names the joker ("Player A - Joker J").
    nation,
    rate: formatBetOdds(gameName, { ...b, win }, displayNetOdds(gameName, b.odds ?? ''), t1),
    amount: Number(b.stake) || b.stake,
    win,
    date: b.created_at,
    ip: b.ip_address ?? b.ip ?? '',
    browser: b.browser ?? b.browser_detail ?? '',
    side,
    deleted: betDeleted(b),
  };
}
